import cx from 'classnames';
import { format } from 'date-fns';

import { convertDate, DateFormatter, formatUTCTimeZone, getTimezoneOffset } from '@flipster/utils/datetime';

import styles from './dateTime.module.scss';
import { NumberFontType } from '../types/base';

interface Props {
  fontType?: NumberFontType;
  value: number | string | null | undefined;
  formatStr?: string;
  isUTC?: boolean;
  withUTCText?: boolean;
  withTimezone?: boolean;
  className?: string;
}

export const DateTime = ({
  fontType = 'num2',
  value,
  formatStr = DateFormatter.DateTime,
  isUTC,
  withUTCText,
  withTimezone,
  className,
}: Props) => {
  const datetime = convertDate(value);

  if (!datetime) return <span>-</span>;

  const formatFunc = isUTC ? formatUTCTimeZone : format;

  return (
    <time className={cx(styles.wrapper, styles[fontType], className)} dateTime={datetime.toISOString()} translate='no'>
      <span>{formatFunc(datetime, formatStr)}</span>
      {isUTC && withUTCText && <span> UTC</span>}
      {withTimezone && <span>{` ${getTimezoneOffset()}`}</span>}
    </time>
  );
};
